export default function addToFavourites() {
  function attachFavouriteListeners() {
    document
      .querySelectorAll("[data-add-offer-to-favourites]")
      .forEach(function (button) {
        const newButton = button.cloneNode(true);
        button.parentNode.replaceChild(newButton, button);

        newButton.addEventListener("click", async function () {
          const offer_id = this.getAttribute("data-offer-id");
          const buttonElement = this;

          try {
            const response = await fetch(
              "/wp-json/estravel/v1/toggle_fav_offer",
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({ offer_id }),
              }
            );

            if (response.ok) {
              buttonElement.classList.toggle("active-favourite");
            } else {
              console.error("Error processing request");
            }
          } catch (error) {
            console.error("Request failed", error);
          }
        });
      });
  }

  attachFavouriteListeners();

  document.addEventListener("facetwp-loaded", function () {
    attachFavouriteListeners();
  });
}
